export default __webpack_public_path__ + "static/media/foodpanda-flutter.91e89488.JPG";